import { useCallback, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getMinCostService } from '~/modules/retailMedia/services/campaign/min-cost'
import { formatDate } from '~/helpers'

export function useApproveCampaign(body: CampaignView) {
  if (body?.adType !== 'digital_signage' || body?.target !== 'invian') {
    return { canApproveCampaign: true, isLoading: false }
  }

  const bodyRequestMinCost = useCallback(() => {
    const places = body?.raw?.places?.map(place => ({ id: place.id })) || []

    return {
      ...body?.raw,
      total_budget: body?.settings?.total_budget,
      end_at: formatDate(body?.raw?.end_at, undefined, 'YYYY-MM-DD'),
      start_at: formatDate(body?.raw?.start_at, undefined, 'YYYY-MM-DD'),
      video: {
        assets: [{ ...body?.ads?.data?.[0]?.settings }]
      },
      settings: {
        ...body?.settings,
        places
      }
    } as DTOCreateDigitalSignageCampaignResponse
  }, [body])

  const { data, isLoading } = useQuery({
    queryKey: ['minCosts', body?.id],
    queryFn: async () => {
      const response = await getMinCostService({
        body: bodyRequestMinCost()
      })

      return response.data
    }
  })

  const canApproveCampaign = useMemo(
    () => data?.can_purchase_reproductions,
    [data?.can_purchase_reproductions]
  )

  return { canApproveCampaign, isLoading }
}
